import axios from "axios";
import jwt_decode from "jwt-decode";
import VueCookies from "vue-cookies";

const baseURL = process.env.VUE_APP_BASE_URL;
const domain = process.env.VUE_APP_DOMAIN;

export function setCookie(token) {
  const decoded = jwt_decode(token);

  const admin = {
    roles: decoded.roles,
    adminId: decoded.userId,
    token: token,
    email: decoded.email
  };
  VueCookies.config("7d");
  if (domain == "localhost") {
    VueCookies.set("admin", admin, "7d", "/", `${domain}`, "", "Lax");
  } else {
    VueCookies.set("admin", admin, "7d", "/", `.${domain}`, "", "Lax");
  }
}

class AuthService {
  login(admin) {
    return axios
      .post(`${baseURL}auth/admin/login`, {
        email: admin.email,
        password: admin.password
      })
      .then(data => {
        if (data.data.statusCode == 200) {
          if (data.data.data.token) {
            setCookie(data.data.data.token);
          }
        }
        return data;
      })
      .catch(error => {
        throw error;
      });
  }

  logout() {
    if (domain == "localhost") {
      VueCookies.remove("admin", "/", `${domain}`);
    } else {
      VueCookies.remove("admin", "/", `.${domain}`);
    }
  }
}

export default new AuthService();



//////////////////
// WEBPACK FOOTER
// ./services/authentication.js
// module id = null
// module chunks = 